import {IUserApi} from '../../../api/user-api.service';
import {IOrganization, IUser, IChangePasswordData} from '../../../api/api.types';
import {StateParams} from 'angular-ui-router';
import {StateService} from 'angular-ui-router';
import IOrganizationApi from '../../../api/organization-api.service';
import {ChangePasswordDialog} from './change-password-dialog.controller';

export interface IUserDetailsStateParams extends StateParams {
    id: string;
}

const changePasswordDialogTemplate = require<string>(
    './change-password-dialog.html');

export default class UserDetailsController {
    private static readonly $inject = ['userApi', '$stateParams', '$state', 'organizationApi', '$mdDialog', '$scope',
    '$timeout', '$translate'];

    private id: number | string;
    private isInsideOrgSetupWizard: boolean;
    private userData: IUser;
    private storedUserData: IUser;
    private isNew: boolean = false;
    private organizationsPromise:ng.IPromise<void>;
    private organizations: IOrganization[];
    private isSaving: boolean = false;
    private isDeleting: boolean = false;
    private isLoading: boolean = true;
    public isEditable: boolean;
    public isCurrentUserSuperAdmin: boolean = false;
    public roles: String[] = ['super_admin', 'admin', 'user'];
    private userForm: ng.IFormController;

    constructor(private userApi: IUserApi,
                private $stateParams: IUserDetailsStateParams,
                private $state: StateService,
                private organizationApi: IOrganizationApi,
                private $mdDialog: ng.material.IDialogService,
                private $scope: ng.IScope,
                private $timeout: ng.ITimeoutService,
                private $translate:ng.translate.ITranslateService) {
    let self = this;

    self.userData = {
        email: null,
        fullName: null,
        id: undefined,
        sourceId: null,
        username: null,
        role: 'user',
        registeredOn: null,
        phone: null
    };

    if (typeof this.isEditable === 'undefined') {
    	this.isEditable = false;
    }

    if (self.$stateParams.id === 'new') {
        self.isNew = true;
        self.isEditable = true;
    } else if (self.$stateParams.id === 'me' || this.id === 'me') {
        userApi.getCurrentUser()
            .then(function (data) {
                delete data.registeredOn;
                self.storedUserData = angular.copy(data);
                self.userData = data;
                self.isLoading = false;

            }, function (errorData) {
              if (!self.isInsideOrgSetupWizard) {
                self.$mdDialog.show(
                    self.$mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title(self.$translate.instant('FAILED_TO_LOAD_USER'))
                        .textContent(errorData.data.details)
                        .ok('OK')
                );
              }
            });
    } else {
        let userId = typeof self.$stateParams.id !== 'undefined' ? parseInt(self.$stateParams.id, 10) : this.id;
        userApi.getUser(userId)
            .then(function (data) {
                delete data.registeredOn;
                self.storedUserData = angular.copy(data);
                self.userData = data;
                self.isLoading = false;
            }, function (errorData) {
                self.$mdDialog.show(
                    self.$mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title(this.$translate.instant('FAILED_TO_LOAD_USER'))
                        .textContent(errorData.data.details)
                        .ok('OK')
                );
            });
    }

    userApi.getCurrentUser()
      .then((data) => {
        if (data.role === 'super_admin') {
          this.isCurrentUserSuperAdmin = true;
          self.organizationsPromise = organizationApi.getOrganizations()
              .then(function(organizations) {
                  if (self.userForm['organization']) {
                    self.userForm['organization'].$setDirty();  
                  }
                  self.organizations = organizations;
                  self.userData.sourceId = data.sourceId;
                  self.isLoading = false;

              }, function (errorData) {
                  if (!self.isInsideOrgSetupWizard) {
                    self.$mdDialog.show(
                        self.$mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title(self.$translate.instant('FAILED_TO_LOAD_ORGANIZATIONS'))
                            .textContent(errorData.data.details)
                            .ok('OK')
                    );
                  }
              });
        } else {
          self.userData.sourceId = data.sourceId;
        }
        self.isLoading = false;
      });

  }

  private onChangePasswordClick($event: MouseEvent) {
    this.$mdDialog.show({
      targetEvent: $event,
      template: changePasswordDialogTemplate,
      controller: ChangePasswordDialog,
      bindToController: true,
      controllerAs: '$ctrl'
    }).then((userData: IChangePasswordData) => {
      this.userApi.changePassword(userData)
        .then(() => {},
          (errorData) => {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('')
                    .textContent(errorData.data.details)
                    .ok('OK')
            );
          });
    });
  }

  private onSaveClick($event: MouseEvent) {
      let self = this;

      delete self.userData.registeredOn;

      self.isSaving = true;

      self.userApi.saveUser(self.userData)
          .then(function (data) {
              self.isSaving = false;
              self.isEditable = false;

              if (self.$stateParams.id === 'new') {
                self.$state.go('user-details', {id: data.id})
              }
          }, function (errorData) {
              self.isSaving = false;

              self.$mdDialog.show(
                  self.$mdDialog.alert()
                      .clickOutsideToClose(true)
                      .title(self.$translate.instant('FAILED_TO_LOAD_ORGANIZATIONS'))
                      .textContent(errorData.data.details)
                      .ok('OK')
                      .targetEvent($event)
              );
          });
  }

  private onBackClick($event: MouseEvent) {
      this.$state.go('user-management');
  }

  private onCancelClick($event: MouseEvent) {
    if (this.isNew) {
      this.$state.go('user-management');
    } else {
      this.isEditable = false;
      this.userData = angular.copy(this.storedUserData);
    }
  }

  private onDeleteClick($event: MouseEvent) {
      let self = this;

      let confirm = this.$mdDialog.confirm()
          .title(this.$translate.instant('DELETE_USER'))
          .textContent(this.$translate.instant('DELETE_CONFIRMATION', {item: self.userData.fullName}))
          .targetEvent($event)
          .ok(this.$translate.instant('DELETE'))
          .cancel(this.$translate.instant('CANCEL'));

      this.$mdDialog.show(confirm).then(function() {

          self.isDeleting = true;

          self.userApi.deleteUser(parseInt(self.$stateParams.id))
              .then(function (data) {
                  self.isDeleting = true;
                  self.$state.go('user-management');
              }, function (errorData) {
                  self.isDeleting = true;

              });
      });

    }

    onSelectOpen() {
        return this.organizationsPromise;
    }

}



/** WEBPACK FOOTER **
 ** ./app/hydromet/userManagement/details/userDetails.controller.ts
 **/